module.exports = __webpack_public_path__ + "img/zuanji.86ca502a.jpg";